webpackJsonp([82],{

/***/ "V7aM":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoGallery = (function () {
    function SectionVideoGallery() {
    }
    return SectionVideoGallery;
}());
angular.module('animatronApp.sectionVideoGallery', []).component('sectionVideoGallery', {
    bindings: {
        ltTitle: '<',
        description: '<',
        videos: '<',
        buttons: '<'
    },
    controller: SectionVideoGallery,
    templateUrl: __webpack_require__("lU18")
});


/***/ }),

/***/ "lU18":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-gallery_59bec7c61b9fc5701eec9ccd9f5dd645.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/82-257c10c0995a4d25fa59.min.js